export const ROLE = {
  csTicket: "cs:ticket",
} as const
